import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary, ThemeProvider } from '@command-center/ui-system';
import {
  DesignSystemProvider,
  parseEnvEnabled,
} from '@command-center/oneup-modern-ui';
import '@command-center/oneup-modern-ui/styles/modern-tokens.css';
import { App } from './App';
import { queryClient } from './lib/queryClient';
import { getBranding } from './platform/branding';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

const brandingForTheme = getBranding();

// Developer override. Modern UI stays OFF by default; this only force-enables it.
const modernUiEnvEnabled = parseEnvEnabled(
  import.meta.env.VITE_ENABLE_MODERN_UI as string | undefined,
);

createRoot(root).render(
  <StrictMode>
    <ThemeProvider
      defaultTheme="light"
      storageKey="oneup-theme"
      colors={brandingForTheme.colors}
    >
      <DesignSystemProvider envEnabled={modernUiEnvEnabled}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <ErrorBoundary title="The app crashed.">
              <App />
            </ErrorBoundary>
          </BrowserRouter>
        </QueryClientProvider>
      </DesignSystemProvider>
    </ThemeProvider>
  </StrictMode>,
);
